import dayjs from "dayjs";
import { RolesMaster } from "../types/assetTypes";
import AddAlertIcon from '@mui/icons-material/AddAlert';
import SearchIcon from '@mui/icons-material/Search';
import React from "react";
import BuildIcon from '@mui/icons-material/Build';
import PublicIcon from '@mui/icons-material/Public';
import FactoryIcon from '@mui/icons-material/Factory';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import { Map } from "@mui/icons-material";
import { FactCheckOutlined } from "@mui/icons-material";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import HomeWorkIcon from "@mui/icons-material/HomeWork"; // for Family Asset
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing"; // for Manufacturer
import GroupIcon from "@mui/icons-material/Group"; // for User
import FlagIcon from "@mui/icons-material/Flag"; // for Country
import MapIcon from "@mui/icons-material/Map"; // for Region
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn"; // for Currency
import WorkIcon from "@mui/icons-material/Work"; // for Project
import ConstructionIcon from "@mui/icons-material/Construction"; // for Technique
import NoticeIcon from  "@mui/icons-material/Construction"; // for Technique
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import GavelIcon from '@mui/icons-material/Gavel';
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import StorageIcon from '@mui/icons-material/Storage';
import Inventory2Icon from "@mui/icons-material/Inventory2"; // for Stock_code
import StorefrontIcon from "@mui/icons-material/Storefront"; // for LocalStore
import CategoryIcon from "@mui/icons-material/Category";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

export const formatDate = (value: string | Date) => {
    return value ? dayjs(value).format('DD-MMM-YYYY') : "";
};

export const MASTER_LIST = [
  {
    name: "Assets",
    role: ["Admin", "Assets List Read", "Assets List Write"],
    icon: React.createElement(PersonIcon),
    children: [    
      { name: "Asset_owner", role: ["Admin", "Assets List Read", "Assets List Write"], icon: React.createElement(BusinessIcon) },
      { name: "Family_asset", role: ["Admin", "Assets List Read", "Assets List Write"], icon: React.createElement(HomeWorkIcon) },     
      { name: "Class_code", role: ["Admin", "Assets List Read", "Assets List Write"], icon: React.createElement(HomeWorkIcon) },
      { name: "Manufacturer", role: ["Admin", "Assets List Read", "Assets List Write"], icon: React.createElement(PrecisionManufacturingIcon) },
      { name: "Model", role: ["Admin", "Assets List Read", "Assets List Write"], icon: React.createElement(PrecisionManufacturingIcon) },
    ],
  },
  {
    name: "Masters List",
    role: ["Admin", "Masters List Read", "Masters List Write"],
    icon: React.createElement(HomeWorkIcon),
    children: [
      { name: "User", role: ["Admin","Masters List Read", "Masters List Write"], icon: React.createElement(GroupIcon) },
      { name: "Country", role: ["Admin","Masters List Read", "Masters List Write"], icon: React.createElement(FlagIcon) },
      { name: "Region", role: ["Admin","Masters List Read", "Masters List Write"], icon: React.createElement(MapIcon) },
      { name: "Currency", role: ["Admin","Masters List Read", "Masters List Write"], icon: React.createElement(MonetizationOnIcon) },
      { name: "Project", role: ["Admin","Masters List Read", "Masters List Write"], icon: React.createElement(WorkIcon) },
      { name: "Technique", role: ["Admin","Masters List Read", "Masters List Write"], icon: React.createElement(ConstructionIcon) }, 
      { name: "Category", role: ["Admin","Masters List Read", "Masters List Write"], icon: React.createElement(CategoryIcon) },   
    ],
  },
  // {
  //   name: "Logistics",
  //   role: ["Admin", "Logistics List Read", "Logistics List Write"],
  //   icon: React.createElement(LocalShippingIcon),
  //   children: [
  //     { name: "Transport_Type", role: ["Admin", "Logistics List Read", "Logistics List Write"], icon: React.createElement(LocalShippingIcon) },
  //     { name: "Status_Logistics", role: ["Admin", "Logistics List Read", "Logistics List Write"], icon: React.createElement(PublishedWithChangesIcon) } ,
  //     {  name: "Transporter",  role: ["Admin", "Logistics List Read", "Logistics List Write"],  icon: React.createElement(PersonIcon)},
  //     {  name: "Supplier",  role: ["Admin", "Logistics List Read", "Logistics List Write"],  icon: React.createElement(PersonOutlineIcon)},


  //     {  name: "Cost_Allocation",  role: ["Admin", "Logistics List Read", "Logistics List Write"],  icon: React.createElement(AttachMoneyIcon)}
          
  //   ],
  // },
  {
    name: "Stores",
    role: ["Admin", "Stores List Read", "Stores List Write"],
    icon: React.createElement(StorefrontIcon),
    children: [
      // { name: "Stock_code", role: ["Admin", "Stores List Read", "Stores List Write"], icon: React.createElement(Inventory2Icon) },
      { name: "LocalStore", role: ["Admin", "Stores List Read", "Stores List Write"], icon: React.createElement(StorefrontIcon) },  
      // { name: "Tools", role: ["Admin", "Logistics List Read", "Logistics List Write"], icon: React.createElement(BuildCircleIcon) },
      // { name: "Equipments", role: ["Admin", "Logistics List Read", "Logistics List Write"], icon: React.createElement(EngineeringIcon) },
    ],
  },
];

export const LOGISTICS_LIST = [
  {
    name: "Transport_Type",
    role: ["Admin", "Logistics List Read", "Logistics List Write"],
    icon: React.createElement(LocalShippingIcon)
  },
  {
    name: "Status_Logistics",
    role: ["Admin", "Logistics List Read", "Logistics List Write"],
    icon: React.createElement(PublishedWithChangesIcon)
  },
  {
    name: "Transporter",
    role: ["Admin", "Logistics List Read", "Logistics List Write"],
    icon: React.createElement(PersonIcon)
  },
  {
    name: "Supplier",
    role: ["Admin", "Logistics List Read", "Logistics List Write"],
    icon: React.createElement(PersonOutlineIcon)
  },
  {
    name: "Cost_Allocation",
    role: ["Admin", "Logistics List Read", "Logistics List Write"],
    icon: React.createElement(AttachMoneyIcon)
  }
];

export const STORES_LIST = [
  {
  name: "Main Database",
  role: ["Admin", "Main Database Read",
  "Main Database Write",
],
  icon: React.createElement(StorageIcon),
},

{
  name: "Country View",
  role: ["Admin",
  "Country View Read",
  "Country View Write",
  ],
  icon: React.createElement(PublicIcon),
},

{
  name: "Stock In Out",
  role: ["Admin",
  "Stock In Out Read",
  "Stock In Out Write",
  ],
  icon: React.createElement(MapIcon),
},

{
  name: "Stock Transactions",
  role: ["Admin", 
  "Stock_Transaction_read",
  "Stock_Transaction_write"], // 👈 you can add more roles as needed
  icon: React.createElement(Inventory2Icon), // 👈 or any relevant icon
}


];



export const MAINTENANCE_LIST = [
  { name: "Report Fault", role: ["Admin","Report Fault Read", "Report Fault Write"], icon: React.createElement(AddAlertIcon) },
  { name: "Fault Database", role: ["Admin","Fault Database Read","Fault Database Write"], icon: React.createElement(SearchIcon) },  
];

export const SERVICES_LIST = [
  
  { name: "New Service", role: ["Admin", "New Service Read",
  "New Service Write",
  
  ], icon: React.createElement(BuildIcon) },
  { name: "Service Template", role: ["Admin", "Service Template Read",  
  "Service Template Write",
 
  ], icon:React.createElement(MiscellaneousServicesIcon) },
  { name: "Service Mapping", role: ["Admin",  
  "Service Mapping Read",
  "Service Mapping Write",
  ], icon:React.createElement(Map) },
  { name: "Service Template Column", role: ["Admin",
  "Service Template Column Read",
  "Service Template Column Write",
  ], icon:React.createElement(Map) },
   { name: "Service Type", role: ["Admin", 
  "Service Type Read",
  "Service Type Write"], icon: React.createElement(BuildCircleIcon) },
  
  
];



export const TIMESHEETS_LIST = [

 
  { name: "View Timesheets", role: ["Admin", "Manager"], icon: React.createElement(VisibilityIcon) },
  { name: "Timesheet Backcharge", role: ["Admin", "Manager"], icon: React.createElement(VisibilityIcon) },
  { name: "Sync with TIPS", role: ["Admin"], icon: React.createElement(SyncAltIcon) }, 
  { name: "Back Charge", role: ["Admin", "Finance"], icon: React.createElement(ReceiptLongIcon) },
  { name: "Invoicing Conditions", role: ["Admin", "Finance"], icon: React.createElement(GavelIcon) },
];


export const BROADCAST_LIST = [
  
  { name: "Broadcast", role:["Admin","Broadcast Read"], icon: React.createElement(NoticeIcon) },
  { name: "Broadcast_Input", role: ["Admin","Broadcast Write"], icon: React.createElement(NoticeIcon) } ,
  
];

export const INSPECTION_LIST = [
  
  { name: "New Inspection", role: ["Admin",
    "New Inspection Read",
  "New Inspection Write",
  
  ], icon: React.createElement(FactCheckOutlined) },
  { name: "Inspection Template", role: ["Admin",
  "Inspection Template Read",
  "Inspection Template Write",
  
  ], icon:React.createElement(MiscellaneousServicesIcon) },
  { name: "Inspection Mapping", role: ["Admin","Inspection Mapping Read",
  "Inspection Mapping Write",  
  ], icon:React.createElement(Map) },
  { name: "Inspection Template Column", role: ["Admin",
  "Inspection Template Column Read",
  "Inspection Template Column Write",
  ], icon:React.createElement(Map) },
  { name: "Inspection Type", role: ["Admin",
  "Inspection Type Read",
  "Inspection Type Write"], icon: React.createElement(AssignmentTurnedInIcon) },
  
];

export const getAccessibleMaintenance = (roles: RolesMaster[]) => {
  const accessibleMaintenance = MAINTENANCE_LIST.filter((maintenance) =>
          roles?.some((role) => maintenance.role.includes(role.roleName))
  );
  return accessibleMaintenance;
};

export const getAccessibleServices = (roles: RolesMaster[]) => {
  const accessibleServices = SERVICES_LIST.filter((services) =>
          roles?.some((role) => services.role.includes(role.roleName))
  );
  return accessibleServices;
};

export const getAccessibleStores = (roles: RolesMaster[]) => {
  const accessibleStores = STORES_LIST.filter((store) =>
    roles?.some((role) => store.role.includes(role.roleName))
  );
  return accessibleStores;
};

export const getAccessibleLogistics = (roles: RolesMaster[]) => {
  const accessibleLogistics = LOGISTICS_LIST.filter((logistic) =>
    roles?.some((role) =>
      logistic.role.includes(role.roleName)
    )
  );
  return accessibleLogistics;
};


export const getAccessibleTimeSheets = (roles: RolesMaster[]) => {
  const accessibleTimeSheets = TIMESHEETS_LIST.filter((timeSheets) =>
          roles?.some((role) => timeSheets.role.includes(role.roleName))
  );
  return accessibleTimeSheets;
};

export const getAccessibleBroadcast = (roles: RolesMaster[]) => {
  const accessibleBroadcast = BROADCAST_LIST.filter((broadcast) =>
          roles?.some((role) => broadcast.role.includes(role.roleName))
  );
  return accessibleBroadcast;
};

export const getAccessibleInspection = (roles: RolesMaster[]) => {
  const accessibleInspection = INSPECTION_LIST.filter((inspection) =>
          roles?.some((role) => inspection.role.includes(role.roleName))
  );
  return accessibleInspection;
};

// export const getAccessibleMasters = (roles: RolesMaster[]) => {
//   const roleNames = roles.map(r => r.roleName);

//   return MASTER_LIST
//     .filter(section => section.role.some(r => roleNames.includes(r)))
//     .map(section => ({
//       ...section,
//       children: section.children.filter(item =>
//         // item.role.some(r => roleNames.includes(r))
//         item.role.length === 0 || item.role.some(r => roleNames.includes(r))
//       ),
//     }));
// };

export const getAccessibleMasters = (roles: RolesMaster[]) => {
  const roleNames = roles.map(r => r.roleName);

  return MASTER_LIST
    // Filter sections where user has access to parent
    .filter(section => section.role.some(r => roleNames.includes(r)))
    // Filter children by role
    .map(section => {
      const filteredChildren = section.children.filter(item =>
        item.role.some(r => roleNames.includes(r))
      );
      return {
        ...section,
        children: filteredChildren
      };
    })
    // Remove parent if no children left
    .filter(section => section.children.length > 0);
};



interface Base64ToFileOptions {
  base64String: string;
  filename: string;
}


export const base64ToFile =({ base64, filename }: { base64: string; filename: string }): File => {
  const arr = base64.split(',');
  const match = arr[0].match(/:(.*?);/);
  const mimeType = match ? match[1] : '';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
  }

  // try {
      const file = new File([u8arr], filename, { type: mimeType });
      return file;
  // } catch (error) {
  //     console.error('Error converting base64 to file:', error);
  // }
}

export const getDefaultPath = (rolesList: string[]) => {
  const accessibleRoute = [
    { segment: "assetInventory", roles: ["Admin", "Plant Manager"] },
    { segment: "masters", roles: ["Admin"] },
    { segment: "stockInventory", roles: ["Admin", "Plant Manager"] },
    { segment: "fileManager", roles: ["Admin"] },
    { segment: "indents", roles: ["Admin", "Plant Manager"] },
  ].find((route) => route.roles.some((role) => rolesList.includes(role)));

  return accessibleRoute ? `/${accessibleRoute.segment}` : "/dashboard"; // Fallback if no match
};

// Function to check if user has at least one allowed role
export const hasAccess = (allowedRoles: string[] = [], roles: RolesMaster[]) => {
    return roles?.some((userRole) => 
      allowedRoles.includes(userRole.roleName) // Check roleName in allowedRoles
    );
  };
